import { fmtExactZoned, fmtMailDate } from "@/components/communications/threadFormat";
import { cn } from "@/lib/utils";
import { ButtonShadcn } from "@/components/ui/Button";

/**
 * The conversations held about this application, newest first — the inbox
 * column of a mail client. A sequence's own name heads its row, and "Direct
 * email" heads one a recruiter wrote by hand, so the two read apart at a
 * glance.
 */
const ThreadList = ({ threads, value, onChange, className }) => (
  <ul aria-label="Conversations" className={cn("divide-y divide-border-primary", className)}>
    {threads.map((thread) => {
      const active = thread.thread_id === value;
      return (
        <li key={thread.thread_id}>
          <ButtonShadcn
            variant="ghost"
            onClick={() => onChange(thread.thread_id)}
            aria-current={active ? "true" : undefined}
            title={fmtExactZoned(thread.last_activity) || undefined}
            className={cn(
              "h-auto w-full flex-col items-stretch gap-0.5 rounded-none px-4 py-3 text-left font-normal whitespace-normal",
              active ? "bg-tone-blue-soft hover:bg-tone-blue-soft" : "hover:bg-background-primary",
            )}
          >
            <span className="flex items-baseline justify-between gap-2">
              <span className="truncate text-sm font-medium text-text-primary">
                {thread.sequence_name || "Direct email"}
                {thread.message_count > 1 && <span className="ml-1 font-normal text-text-secondary">{thread.message_count}</span>}
              </span>
              <span className="shrink-0 text-xs text-text-secondary">{fmtMailDate(thread.last_activity)}</span>
            </span>
            <span className="truncate text-sm text-text-primary">{thread.subject || "(no subject)"}</span>
            {thread.last_preview && <span className="truncate text-xs text-text-secondary">{thread.last_preview}</span>}
          </ButtonShadcn>
        </li>
      );
    })}
  </ul>
);

export default ThreadList;
